import { render, staticRenderFns } from "./icon-row.vue?vue&type=template&id=e6607404&"
import script from "./icon-row.vue?vue&type=script&lang=ts&"
export * from "./icon-row.vue?vue&type=script&lang=ts&"
import style0 from "./icon-row.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex})
